var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('d-player',{attrs:{"options":{
      autoplay: true,
      volume: 0.7,
      video: { url: _vm.url }
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }